import React, {memo, useCallback, useEffect, useMemo, useState} from "react"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {InputModel} from "../../../../types/control"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useDispatch, useSelector} from "react-redux"
import {useSetSelector} from "../../../../hooks/set-selector"
import {useHistory, useParams} from "react-router-dom"
import {useLocalization} from "../../../../hooks/localization"
import {useRPC} from "../../../../hooks/rpc"
import {setReadAllTempFunc} from "../../../../store/control/actions"
import { useMessage } from "../../../../hooks/message"

const keyExtractor = (item: InputModel) => item.id
let timer
export const MultipleTemperatureListScreen = memo(function MultipleTemperatureListScreen() {
    const {t} = useLocalization()
    const dispatch = useDispatch()
    const history = useHistory()
    const params = useParams()
    const [rpc] = useRPC()
    const {failure} = useMessage();
    const bridgeDeviceSet = useSetSelector(state => state.control.bridgeDeviceList)
    const advanedTemperatureInputList = useSelector(state => state.control.inputList).filter(control => control.type_id === "6")
    const inputTypeSet = useSetSelector(state => state.control.inputTypeList)
    const [selectedInput, setSelectedInput] = useState<InputModel>(null)
    const temperatureReadingStatus = useSelector(state => state.control.readAllTempFunc)
    const [readTempStatus, setReadTempStatus] = useState(false)

    const displayNameExtractor = useCallback(
        (item: InputModel, column: ColumnModel) => {
            if (column.key === "bridge_device_id") {
                return bridgeDeviceSet[item.bridge_device_id]?.name
            }

            if (column.key === "type_id") {
                return inputTypeSet[item.type_id].name
            }

            return item[column.key]?.toString() || "-"
        },
        [bridgeDeviceSet, inputTypeSet]
    )

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: t("input_name"),
                key: "name"
            },
            {
                length: 2,
                name: t("device"),
                key: "bridge_device_id"
            },
            {
                length: 1,
                name: t("type"),
                key: "type_id"
            },
            {
                length: 2,
                name: t("multiple_temperature.temperature"),
                key: "current_temperature"
            },
            {
                length: 1,
                name: t("input"),
                key: "input_number"
            }
        ],
        [t]
    )

    const onMatchAdvancedInput = useCallback(() => {
        rpc.ScanTemperatureSensor()
    }, [rpc])

    const onResetAdvancedInput = useCallback(() => {
        rpc.DefaultTemperatureSensor()
    }, [rpc])

    const inputLength = Number(advanedTemperatureInputList.length)
    const onReadTemperature = useCallback(() => {
        if (inputLength <= 0) {
            failure("İnput bulunamadı!")
            return
        }
        let newReadTempStatus = readTempStatus
        if (readTempStatus) {
            newReadTempStatus = false
        } else {
            newReadTempStatus = true
        }
        setReadTempStatus(newReadTempStatus)
    }, [readTempStatus, inputLength, failure])

    useEffect(() => {
        if (inputLength <= 0) {
            return
        }
        let requestLoopStatus = readTempStatus
        if (requestLoopStatus) {
            timer = setInterval(() => {
                rpc.ReadAllTemperatureSensor()
            }, inputLength * 1000)
            return () => clearInterval(timer)
        }
    }, [rpc, inputLength, readTempStatus])

    const buttons = useMemo(
        () => [
            {
                text: readTempStatus ? t("multiple_temperature.stop_reading") : t("multiple_temperature.temperature_read"),
                onClick: onReadTemperature,
                className: "blue"
            },
            {
                text: t('reset'),
                onClick: onResetAdvancedInput,
                className: "red"
            },
            {
                text: t("multiple_temperature.scan"),
                onClick: onMatchAdvancedInput,
                className: "yellow"
            },
            {
                text: t("edit"),
                url: `/settings/multiple-temperature/edit/${selectedInput ? selectedInput.id : ""}`,
                className: "orange",
                hidden: !selectedInput
            }
        ],
        [t, selectedInput, onMatchAdvancedInput, onReadTemperature, onResetAdvancedInput, readTempStatus]
    )

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                //@ts-ignore
                buttons={buttons}
                className="camera-list-page"
                backUrl={"/settings"}
                searchable={true}
            >
                <SettingsList
                    columns={columns}
                    items={advanedTemperatureInputList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedInput}
                    onItemSelected={setSelectedInput}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
